/**
 * The roles that can be assigned to a staff account from the ERP.
 *
 * GET /User/Roles returns everything the database holds, including roles that are
 * granted elsewhere and must not appear in this dropdown: "Client" and "User" are
 * given by the app's own registration, "Dashboard" is system access rather than a
 * job, and "ClientManager" is set per pousada on the client screen.
 *
 * "Laundry" is the employee who counts the pieces when an order arrives; without it
 * here the role existed in the database with no way to hand it to anybody.
 */
export const staffRoles = ["Assistant", "Attendant", "Admin", "Driver", "Laundry"];

export default staffRoles;
